// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1StateSchema } from './v1/stateSchema';
import { v1StatesCreateSchema } from './v1/states/createSchema';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';

export const createStatePathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createStateHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description State created successfully
 */
export const createState201Schema = z.lazy(() => v1StateSchema);

/**
 * @description Access denied - admin required
 */
export const createState404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Validation failed
 */
export const createState422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createStateMutationRequestSchema = z.lazy(() => v1StatesCreateSchema);

export const createStateMutationResponseSchema = z.lazy(() => createState201Schema);
